import {
	Card,
	makeStyles,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography
} from '@material-ui/core';
import TableContainer from "@material-ui/core/TableContainer";
import React from 'react';
import * as dayjs from 'dayjs';
import { useValues } from 'kea';
import Chart from "react-google-charts";

import { rbeaconmovementlogic } from 'src/store/report';

import AssetDialog from './AddDataDialogs/AssetDialog';
import CSVDialog from '../../../utils/CSVDialog';
import PDFDialog from '../../../utils/PDFDialog'
import vehiclelogic from 'src/store/vehicle';
import prettytime from '../../../utils/prettytime';

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

const columns = [
	{
		field: 'timestamp',
		headerName: 'Timestamp',
		align: 'left',
		width: 100,
	},
	{
		field: 'address',
		headerName: 'Address',
		align: 'left',
		width: 180,
	},
	{
		field: 'temperature',
		headerName: 'Temperature (°C)',
		align: 'left',
		width: 180,
	},
];


const initialRowsPerPage = 10;

function tooltip(name, start, stop) {
	return `<div style="padding:10px;font-size:16px;font-family:Arial;width:300px">
		<div style="text-align:center">${name}</div>
		<hr />
		<b>Entered:</b> ${dayjs(start).format('DD/MM/YY HH:mm')}<br>
		<b>Exited:</b> ${dayjs(stop).format('DD/MM/YY HH:mm')}<br>
		<b>Duration:</b> ${prettytime(dayjs(stop).diff(dayjs(start)) / 1000)}<br>
	</div>`
}

const BeaconMovement = () => {
	const classes = useStyles();
	// const [page, setPage] = React.useState(0);
	const { report } = useValues(rbeaconmovementlogic);
	const { vehicles } = useValues(vehiclelogic);
	const [rowsPerPage, setRowsPerPage] = React.useState(initialRowsPerPage);
	const rows = report?.events?.filter(p => (new Date(p.stop_time)).getTime() > (new Date(p.start_time)).getTime()) || [];
	const [data, setData] = React.useState(null);
	const [exportData, setExportData] = React.useState([]);

	React.useEffect(() => {
		if (rows.length) {
			let points = [
				[
					{ type: 'string', id: 'Vehicle' },
					{ type: 'string', id: "dummy bar label" },
					{ type: 'string', role: 'tooltip' },
					{ type: 'date', id: 'Start' },
					{ type: 'date', id: 'End' }
				],
				...rows.map(p => {
					let name = vehicles.find(v => v.tracker.imei === p.tracker).name;
					let start = new Date(p.start_time);
					let stop = new Date(p.stop_time);
					// console.log(name, start, stop);
					return [name, '', tooltip(name, start, stop), start, stop]
				})
			];
			// console.log(points);

			setData(points);
		}
		// let newExportData = rows.map(row => {
		// 	return {
		// 		timestamp: `${dayjs(row.position_timestamp).format('HH:mm:ss  DD MMM YYYY')}`,
		// 		address: row.address,
		// 		temperature: row.io.temperature
		// 	}
		// })
		// setExportData(newExportData);
	}, [report])
	// console.log(data)
	return (
		<>
			<div style={{ display: 'flex', flexGrow: 1 }}>
				<AssetDialog />
				<div
					style={{ paddingLeft: '15px' }}>
				</div>
				{/* {
					rows.length > 0 ?
						<CSVDialog columns={columns} additionalData={[
							report.asset ?
								`${report.asset.type} - ${report.asset.company} ${report.asset.model} ${report.asset.color}`
								:
								'No Data']} rows={exportData} filename={`Temperature_Report - ${dayjs().format('HH:mm:ss  DD MMM YYYY')}.csv`} />
						:
						null
				}
				<div
					style={{ paddingLeft: '15px' }}>
				</div>
				{
					rows.length > 0 ?
						<PDFDialog
							columns={columns} rows={exportData} title='Temperature Report'
							filename={`Temperature_Report - ${dayjs().format('HH:mm:ss  DD MMM YYYY')}.pdf`} />
						:
						null
				} */}
			</div>
			<div
				style={{ paddingTop: '15px' }}>
			</div>
			<Card
				className={classes.root}
			>
				<div style={{ height: '100%', width: '100%', background: 'white' }}>
					<TableContainer className={classes.container}>
						<Table stickyHeader aria-label="sticky table" size={'small'}>
							<TableHead>
								<TableRow>
									<TableCell colSpan={6} align={'left'}>
										<Typography variant="h4" >
											Beacon Movement Report
										</Typography>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell
										colSpan={7}
									>
										{
											report.asset
												?
												<Typography>
													{`${report.asset.type} - ${report.asset.company} ${report.asset.model} ${report.asset.color}`}
												</Typography>
												:
												<Typography>
													No Data
												</Typography>
										}
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow>
									<TableCell style={{ height: 33 * rowsPerPage }} colSpan={5} align={'center'}>
										{data ? <Chart
											width={'100%'}
											height={'300px'}
											chartType="Timeline"
											loader={<div>Loading Chart</div>}
											data={data}
											options={{
												showRowNumber: true,
												allowHtml: true
											}}
											rootProps={{ 'data-testid': '1' }}
										/> : 'Please Generate the Report first.'
										}
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
					{/* </Paper> */}
				</div>
			</Card>
		</>
	);
};


export default BeaconMovement;